/** Тексти скасування дії (UX-14; audit-undo.md, розд. 6). Без дієслова в роді. */
export const undoText = {
  done: (what: string) => `Скасовано: ${what}`,
  sent: (labels: string) => `Скасовано, але вже надіслано: ${labels} — це не відкликати`,
  nothing: 'Нічого скасовувати',
  offline: 'Немає зв’язку: скасувати зараз не можна',
  failed: 'Не вдалося скасувати',
  reasons: {
    undo_conflict: 'Не вдалося скасувати: значення вже змінено',
    undo_expired: 'Час для скасування минув',
    not_found: 'Запис уже недоступний',
    undo_unavailable: 'Цю дію не можна скасувати',
    state_conflict: 'Не вдалося скасувати: стан запису вже змінився',
    already_undone: 'Цю дію вже скасовано',
  } as Record<string, string>,
};
